import { useQuery } from 'react-query';

import { getCrawlingInsectsTrap } from 'api/traps/CrawlingInsectsTrap/getCrawlingInsectsTrap';
import { TrapTableType } from 'components/TrapsTables/trapTables';

export const useGetCrawlingInsectsTraps = (slug: string, page: number, search?: string, ordering?: string) => {
  const { data, refetch, isLoading } = useQuery(
    TrapTableType.CrawlingInsectsTrap,
    () => getCrawlingInsectsTrap(slug, page, search, ordering),
    {
      refetchOnWindowFocus: false,
    },
  );

  return { data, refetch, isLoading };
};

export default useGetCrawlingInsectsTraps;
